import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

export default class FilterSportsPoolReportView extends JetView {
    /**
     * Configures the UI components for the view
     * @returns {Object} Configuration object for the view
     */
    config(){
        const _ = this.app.getService("locale")._;
        // Layout for the left side of the filter panel
        const left = {
            margin: 15,
            css: 'on-row', // Row styling
            cols:[
                {
                    view:'text', // Text field for date range (readonly, opens custom modal)
                    id:'Datepicker',
                    name:'Datepicker',
                    css:'reportrange',
                    readonly:true,
                    label:"<span class='webix_icon icon-calendar'></span>"+_('Rango de fechas'),
                    labelPosition:'top',
                    placeholder:_('Click para seleccionar ')
                },
                {
                    view:'datepicker', // Single date selector
                    id:'Date',
                    name:'Date',
                    stringResult:true,
                    minWidth:200,
                    label:"<span class='webix_icon icon-calendar'></span>"+_('Fecha'),
                    labelPosition:'top',
                    placeholder:_('Selecciona fecha'),
                    value: moment().format("YYYY-MM-DD"), // Default to current date
                    format:'%d %M %Y', // Display format
                    suggest:{ type:'calendar', body:{ maxDate:new Date() } } // Restrict future dates
                },
                {
                    view:'text', // Input field for forecast ID
                    id:'forecastId',
                    name:'forecastId',
                    label:_("ID de Polla"),
                    placeholder:_("Ingresa ID de Polla"),
                    labelPosition:'top'
                },
            ]
        };

        // Action buttons layout
        const buttons = {
            cols:[
                {}, // Spacer to align buttons to the right
                {
                    view:'button', // Clear button
                    value:_('Limpiar'),
                    width:130,
                    click: ()=> this.getRoot().clear() // Clear all form values
                },
                {
                    view:'button', // Consult button
                    value:_('Consultar'),
                    type:'form',
                    hotkey:'enter', // Trigger on Enter key
                    width:130,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values

                        // Remove unused date field depending on typeDate
                        if (profile.typeDate !== 2){
                            delete filterdata['Date'];
                        } else {
                            delete filterdata['Datepicker'];
                        }

                        // Trigger filter event for main report
                        this.app.callEvent("sportsPoolReport:filter", [filterdata]);

                        // Collapse panel if exists
                        const panel = $$("b5");
                        if (panel && panel.collapse) panel.collapse();

                        // Hide popup if exists
                        const popup = $$("filterPopup");
                        if (popup && popup.hide) popup.hide();
                    }
                }
            ]
        };

        // Accordion layout for larger screens
        const accordion = {
            view:'accordion', // Accordion container
            multi:true, // Allow multiple sections open at the same time
            collapsed:true, // Start collapsed by default
            rows:[
                {
                    id:'b5', // Accordion section for filters
                    header:_('Filtros'), // Section title
                    body:{
                        padding:10, // Inner padding
                        rows:[left, { height:20 }, buttons] // Content: filter fields, spacer, and action buttons
                    }
                }
            ]
        };

        // Popup layout for smaller screens
        const filterPopup = webix.ui({
            view:'window', // Popup window
            id:'filterPopup',
            move:true, // Allow window dragging
            fullscreen:true, // Open fullscreen
            head:{
                view:'toolbar', // Toolbar as popup header
                cols:[
                    { view:'label', label:_('Filtros'), align:'center' }, // Title label
                    { view:'icon', icon:'wxi-close', click:function(){ this.getTopParentView().hide(); } } // Close button
                ]
            },
            body:{
                view:'form', // Form inside popup
                id:'myForm2',
                type:'clean',
                rows:[left, buttons] // Contains filter fields and action buttons
            }
        });

        return {
            view:'form', // Main form container
            type:'clean', // Clean layout (no extra borders/padding)
            rows:[
                // Show accordion if screen is larger than 500x500, otherwise render hidden placeholder
                (screen.width>500 && screen.height>500) ? accordion : {height:1, width:0}
            ]
        };
    }

    /**
     * Initializes the view and fetches necessary data
     */
    init(){
        const lang = this.app.getService('locale').getLang(); // Get current language from locale service
        $$('Datepicker').attachEvent("onAfterRender", ()=> devConfig.setDateModal(lang)); // Configure date modal after Datepicker renders

        webix.ready(function(){
            // Toggle visibility between Date and Datepicker depending on typeDate
            if (profile.typeDate !== 2){
                $$('Date').hide(); // Hide single date selector
                $$('Datepicker').show(); // Show date range field
            } else {
                $$('Date').show(); // Show single date selector
                $$('Datepicker').hide(); // Hide date range field
            }
        });
    }
}
